import InfinitiveList from 'app/modules/ui/components/list/infinitive';
import { useInfinitive } from 'app/modules/ui/hooks/useInfinitive';
import React from 'react';
import styled from '@emotion/styled';
import Card from 'app/components/Card';
import ProductItem from 'app/pages/TemplateManagment/components/ProductItem';
import { GetListResponse, GetOneResponse } from 'app/context/data/types';

const StyledCard = styled(Card)`
  height: 100%;
  background: #fff;
  overflow: auto;
  padding-bottom: 16px;
`;

const StyledProductItem = styled(ProductItem)`
  .wrapperDescription {
    width: 100%;
    > div:nth-of-type(3) {
      > div {
        width: 100%;
        > div {
          &:last-of-type {
            width: 90%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }
`;

type ListProductProps = {
  inspectionId: string;
};

export const ListProduct: React.FC<ListProductProps> = ({ inspectionId }) => {
  const [loaderRef, { hasMore, data }] = useInfinitive({
    resource: 'inspections/:id/products',
    pagination: {
      current: 1,
      pageSize: 5
    },
    meta: {
      id: inspectionId
    },
    queryOption: {
      skip: !inspectionId
    }
  });
  return (
    <InfinitiveList
      loaderRef={loaderRef}
      infinitiveConfig={{
        hasMore,
        dataLength: (data ?? []).length
      }}
      dataSource={data ?? []}
      rowKey={(item: { id: string | number }) => item.id}
      itemHeight={120}
      split={false}
      renderItem={(item: any, index) => {
        return (
          <StyledProductItem
            buttonProps={{ hidden: true }}
            order={index}
            hiddenOrder
            product={item}
            linkageTemplate={item?.inspectionCriteria}
          />
        );
      }}
    />
  );
};
